module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }